import { API_URL } from "../config";

/**
 * @param {File} file
 * @param {string} [apiUrl]
 * @returns {Promise<{ ok: true, url: string } | { ok: false, error: string }>}
 */
export async function uploadTestQuestionImage(file, apiUrl = API_URL) {
  if (!(file instanceof File)) {
    return { ok: false, error: "Archivo no válido." };
  }
  if (!/^image\/(png|jpeg|gif|webp)$/i.test(file.type || "")) {
    return { ok: false, error: "Formato de imagen no válido. Usa PNG, JPG, GIF o WebP." };
  }
  let contenidoBase64;
  try {
    contenidoBase64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => reject(new Error("No se pudo leer la imagen."));
      reader.readAsDataURL(file);
    });
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error.message : "No se pudo leer la imagen.",
    };
  }
  let res;
  try {
    res = await fetch(`${apiUrl}/subir-imagen-curso`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre: file.name,
        tipo: file.type,
        contenidoBase64,
      }),
    });
  } catch {
    return { ok: false, error: "No se pudo conectar con el servidor." };
  }
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok || !data || typeof data.url !== "string" || data.url.trim() === "") {
    const msg =
      data && typeof data.error === "string" ? data.error : `Error al subir imagen (${res.status})`;
    return { ok: false, error: msg };
  }
  return { ok: true, url: data.url.trim() };
}
